module.exports = __webpack_public_path__ + "images/psp/SelfStorage/indoor-climate-controlled-storage-units.webp";